/**
 * Keeps the "Selected / Full frame / Price" summary in step with the
 * variant picker. Dawn fetches the whole product section on every
 * change and publishes the parsed HTML; we lift our block out of it.
 */
(function () {
  // Dawn declares these with top-level const, so they are not window properties.
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.html || !data.sectionId) return;
    var source = data.html.querySelector('#DauSummary-' + data.sectionId);
    var destination = document.getElementById('DauSummary-' + data.sectionId);
    if (source && destination) destination.innerHTML = source.innerHTML;
  });
})();
